import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RegistrationLayout } from "../../../RegistrationLayout/RegistrationLayout";
import { RegistrationSetupNavbar } from "../../../RegistrationLayout/RegistrationSetupNavbar";
import RegistrationSetupWrapper from "../../RegistrationSetup.style";
import {
  REGISTRATION_SETUP_STEP_META,
  REGISTRATION_SETUP_TOTAL_STEPS,
} from "../../../../helper/constants";
import { clearRegistrationData } from "../../registrationSetupStorage";
import poppieGif from "../../../../assets/images/poppiegifnew.gif";

const DOWNLOAD_STEP = REGISTRATION_SETUP_STEP_META.APP_DOWNLOAD;

const RegistrationAllSet = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevRootHeight = root?.style.height ?? "";

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    if (root) {
      root.style.height = "100vh";
      root.style.height = "100dvh";
    }

    clearRegistrationData();

    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      if (root) {
        root.style.height = prevRootHeight;
      }
    };
  }, []);

  return (
    <RegistrationSetupWrapper>
      <RegistrationLayout
        containScroll
        header={
          <RegistrationSetupNavbar
            stepMeta={DOWNLOAD_STEP}
            totalSteps={REGISTRATION_SETUP_TOTAL_STEPS}
            showBack={false}
          />
        }
      >
        <div className="scroll-body">
          <div className="content-card content-card-all-set">
            <div className="content-card-scroll content-card-scroll-all-set">
              <div className="all-set-hero">
                <div className="all-set-gif-wrap">
                  <img
                    src={poppieGif}
                    alt=""
                    className="all-set-gif"
                  />
                </div>
                <h2 className="all-set-title">
                  {t("NUTRITION_ALLSET_LBL_MESSAGE")}
                </h2>
              </div>
            </div>
          </div>
        </div>
      </RegistrationLayout>
    </RegistrationSetupWrapper>
  );
};

export default withRouter(RegistrationAllSet);
